<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18 2H6a1 1 0 00-1 1v18a1 1 0 001 1h12a1 1 0 001-1V3a1 1 0 00-1-1zm-1 2v3H7V4zM7 20V9h10v11z"/><path d="M14.25 13.5h-4.5a.5.5 0 000 1h4.5a.5.5 0 000-1zM14.25 16.5h-4.5a.5.5 0 000 1h4.5a.5.5 0 000-1z"/></svg>